export default {"src":"/_next/static/media/youtube.7996c934.svg","height":1000,"width":1000};